import { AbstractGridStrategy } from './abstract.strategy';
import { UNLIMITED_AMOUNT } from 'components/system/data-provider/abstract-data-provider-v2';

export class AllItemsGridStrategy extends AbstractGridStrategy {
    private withPagination = false;

    constructor(showPagination: boolean = false) {
        super();
        this.itemsOnPage = UNLIMITED_AMOUNT;
        this.withPagination = showPagination;
    }

    public getGridHeight(): number {
        return 0;
    }

    public getGridPageAmount(): number {
        return this.itemsOnPage;
    }

    public showPagination() {
        return this.withPagination;
    }

    public usesAllItems(): boolean {
        return true;
    }

    public detach() {}
    public setGridElement(gridElement: HTMLElement): void {}
}
